import { DashboardService, DashboardError } from '@/services/dashboard.service';

const state = {
  balances: [
    { name: '', balance: 0 },
    { name: '', balance: 0 },
    { name: '', balance: 0 },
    { name: '', balance: 0 },
  ],
  stats: [],
  charts: [],
  serverResponse: null,
};

const getters = {
  balances: (state) => {
    return state.balances;
  },
  stats: (state) => {
    return state.stats;
  },
  charts: (state) => {
    return state.charts;
  },
  serverResponse: (state) => {
    return state.serverResponse;
  },
};

const actions = {
  async fetchBalances({ commit }) {
    try {
      const response = await DashboardService.fetchBalances();
      commit('fetchBalancesSuccess', response);
      return true;
    } catch (e) {
      if (e instanceof DashboardError) {
        commit('dataFetchAllError', {
          status: e.errorCode,
          message: e.message,
        });
      }

      return false;
    }
  },

  async fetchCharts({ commit }) {
    try {
      const response = await DashboardService.fetchCharts();
      commit('fetchChartsSuccess', response);
      return true;
    } catch (e) {
      if (e instanceof DashboardError) {
        commit('dataFetchAllError', {
          status: e.errorCode,
          message: e.message,
        });
      }

      return false;
    }
  },

  async fetchStats({ commit }) {
    try {
      const response = await DashboardService.fetchStats();
      commit('fetchStatsSuccess', response);
      return true;
    } catch (e) {
      if (e instanceof DashboardError) {
        commit('dataFetchAllError', {
          status: e.errorCode,
          message: e.message,
        });
      }

      return false;
    }
  },
};

const mutations = {
  fetchBalancesSuccess(state, response) {
    state.balances = response;
  },
  fetchChartsSuccess(state, response) {
    state.charts = response;
  },
  fetchStatsSuccess(state, response) {
    state.stats = response;
  },

  dataFetchAllError(state, response) {
    state.serverResponse = response;
  },
};

export const dashboard = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
